import { createTextComponent } from './text.component'

/* Styles ======================================================================================= */
import { headingClass } from './heading.class'

export const Heading = createTextComponent(headingClass)
